/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { QueryProvider } from '@thd-nucleus/data-sources';

const ssr = typeof window === 'undefined';

let DisclaimerMessageImport;
let ConsumerCardMessagingImport;
let PaintDeliveryBannerImport;
let SuperSkuImport;
let MovingCalculatorImport;
let OrderSampleImport;
let GlobalCustomConfiguratorImport;
let AugmentedRealityImport;
let AisleBayImport;
let QuestionsAndAnswersAccordionBodyImport;
let RatingsAndReviewsAccordionBodyImport;
let SpecificationsAccordionBodyImport;
let ProductOverviewAccordionBodyImport;

/** *********************
 * Aisle Bay
 ********************** */
export const AisleBayLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "aisle-bay" */
  '@thd-olt-component-react/aisle-bay'
).then((module) => {
  const { AisleBay } = module;

  AisleBayImport = (props) => {
    return (
      <QueryProvider defaultVariables={props.qctx.defaultVariables.current}>
        <AisleBay {...props} />
      </QueryProvider>
    );
  };
});

export const AisleBay = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/aisle-bay')).AisleBay
  : (props) => <AisleBayImport {...props} />;

export const AisleBayModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/aisle-bay')).AisleBay
    .dataModel
  : {};

/** *********************
 * Disclaimer Message
 ********************** */
export const DisclaimerMessageLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "disclaimer-message" */
  '@thd-olt-component-react/disclaimer-message'
).then((module) => {
  const { DisclaimerMessage } = module;

  DisclaimerMessageImport = (props) => {
    return (
      <QueryProvider defaultVariables={props.qctx.defaultVariables.current}>
        <DisclaimerMessage {...props} />
      </QueryProvider>
    );
  };
});

export const DisclaimerMessage = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/disclaimer-message'))
    .DisclaimerMessage
  : (props) => <DisclaimerMessageImport {...props} />;

export const DisclaimerMessageModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/disclaimer-message'))
    .DisclaimerMessage.dataModel
  : {};

/** *********************
 * Consumer Card Messaging
 ********************** */
export const ConsumerCardMessagingLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "consumer-card-messaging" */
  '@thd-olt-component-react/consumer-card-messaging'
).then((module) => {
  const { ConsumerCardMessaging } = module;

  ConsumerCardMessagingImport = (props) => {
    return (
      <QueryProvider defaultVariables={props.qctx.defaultVariables.current}>
        <ConsumerCardMessaging {...props} />
      </QueryProvider>
    );
  };
});

export const ConsumerCardMessaging = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/consumer-card-messaging'))
    .ConsumerCardMessaging
  : (props) => <ConsumerCardMessagingImport {...props} />;

export const ConsumerCardMessagingModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/consumer-card-messaging'))
    .ConsumerCardMessaging.dataModel
  : {};

/** *********************
 * Paint Deliver Banner
 ********************** */
export const PaintDeliveryBannerLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "paint-delivery-banner" */
  '@thd-olt-component-react/paint-delivery-banner'
).then((module) => {
  const { PaintDeliveryBanner } = module;

  PaintDeliveryBannerImport = (props) => {
    return (
      <QueryProvider defaultVariables={props.qctx.defaultVariables.current}>
        <PaintDeliveryBanner {...props} />
      </QueryProvider>
    );
  };
});

export const PaintDeliveryBanner = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/paint-delivery-banner'))
    .PaintDeliveryBanner
  : (props) => <PaintDeliveryBannerImport {...props} />;

export const PaintDeliveryBannerModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/paint-delivery-banner'))
    .PaintDeliveryBanner.dataModel
  : {};

/** *********************
 * Super Sku
 ********************** */
export const SuperSkuLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "super-sku" */
  '@thd-olt-component-react/super-sku'
).then((module) => {
  const { SuperSku } = module;

  SuperSkuImport = (props) => {
    return (
      <QueryProvider defaultVariables={props.qctx.defaultVariables.current}>
        <SuperSku {...props} />
      </QueryProvider>
    );
  };
});

export const SuperSku = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/super-sku')).SuperSku
  : (props) => <SuperSkuImport {...props} />;

export const SuperSkuModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/super-sku')).SuperSku
    .dataModel
  : {};

/** *********************
 * Moving Calculator
 ********************** */
export const MovingCalculatorLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "moving-calculator" */
  '@thd-olt-component-react/moving-calculator'
).then((module) => {
  const { MovingCalculator } = module;

  MovingCalculatorImport = (props) => {
    return (
      <QueryProvider defaultVariables={props.qctx.defaultVariables.current}>
        <MovingCalculator {...props} />
      </QueryProvider>
    );
  };
});

export const MovingCalculator = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/moving-calculator'))
    .MovingCalculator
  : (props) => <MovingCalculatorImport {...props} />;

export const MovingCalculatorModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/moving-calculator'))
    .MovingCalculator.dataModel
  : {};

/** *********************
 * Order Sample
 ********************** */
export const OrderSampleLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "order-sample" */
  '@thd-olt-component-react/order-sample'
).then((module) => {
  const { OrderSample } = module;

  OrderSampleImport = (props) => {
    return (
      <QueryProvider defaultVariables={props.qctx.defaultVariables.current}>
        <OrderSample {...props} />
      </QueryProvider>
    );
  };
});

export const OrderSample = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/order-sample')).OrderSample
  : (props) => <OrderSampleImport {...props} />;

export const OrderSampleModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/order-sample')).OrderSample
    .dataModel
  : {};

/** *********************
 * Global Custom Configurator
 ********************** */
export const GlobalCustomConfiguratorLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "global-custom-configurator" */
  '@thd-olt-component-react/global-custom-configurator'
).then((module) => {
  const { GlobalCustomConfigurator } = module;

  GlobalCustomConfiguratorImport = (props) => {
    return (
      <QueryProvider defaultVariables={props.qctx.defaultVariables.current}>
        <GlobalCustomConfigurator {...props} />
      </QueryProvider>
    );
  };
});

export const GlobalCustomConfigurator = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/global-custom-configurator'))
    .GlobalCustomConfigurator
  : (props) => <GlobalCustomConfiguratorImport {...props} />;

export const GlobalCustomConfiguratorModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/global-custom-configurator'))
    .GlobalCustomConfigurator.dataModel
  : {};

/** *********************
 * Augmented Reality
 ********************** */
export const AugmentedRealityLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "augmented-reality" */
  '@thd-olt-component-react/augmented-reality'
).then((module) => {
  const { AugmentedReality } = module;

  AugmentedRealityImport = (props) => {
    return (
      <QueryProvider defaultVariables={props.qctx.defaultVariables.current}>
        <AugmentedReality {...props} />
      </QueryProvider>
    );
  };
});

export const AugmentedReality = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/augmented-reality'))
    .AugmentedReality
  : (props) => <AugmentedRealityImport {...props} />;

export const AugmentedRealityModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/augmented-reality'))
    .AugmentedReality.dataModel
  : {};

/** *********************
 * Questions and Answers
 ********************** */
export const QuestionsAndAnswersAccordionBodyLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "questions-and-answers" */
  '@thd-olt-component-react/questions-and-answers'
).then((module) => {
  const { QuestionsAndAnswersAccordionBody } = module;

  QuestionsAndAnswersAccordionBodyImport = (props) => {
    return (
      <QueryProvider defaultVariables={props.qctx.defaultVariables.current}>
        <QuestionsAndAnswersAccordionBody {...props} />
      </QueryProvider>
    );
  };
});

export const QuestionsAndAnswersAccordionBody = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/questions-and-answers'))
    .QuestionsAndAnswersAccordionBody
  : (props) => <QuestionsAndAnswersAccordionBodyImport {...props} />;

export const QuestionsAndAnswersAccordionBodyModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/questions-and-answers'))
    .QuestionsAndAnswersAccordionBody.dataModel
  : {};

/** *********************
 * Ratings and Reviews
 ********************** */
export const RatingsAndReviewsAccordionBodyLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "ratings-and-reviews" */
  '@thd-olt-component-react/ratings-and-reviews'
).then((module) => {
  const { RatingsAndReviewsAccordionBody } = module;

  RatingsAndReviewsAccordionBodyImport = (props) => {
    return (
      <QueryProvider defaultVariables={props.qctx.defaultVariables.current}>
        <RatingsAndReviewsAccordionBody {...props} />
      </QueryProvider>
    );
  };
});

export const RatingsAndReviewsAccordionBody = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/ratings-and-reviews'))
    .RatingsAndReviewsAccordionBody
  : (props) => <RatingsAndReviewsAccordionBodyImport {...props} />;

export const RatingsAndReviewsAccordionBodyModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/ratings-and-reviews'))
    .RatingsAndReviewsAccordionBody.dataModel
  : {};

/** *********************
 * Specifications
 ********************** */
export const SpecificationsAccordionBodyLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "specifications" */
  '@thd-olt-component-react/specifications'
).then((module) => {
  const { SpecificationsAccordionBody } = module;

  SpecificationsAccordionBodyImport = (props) => {
    return (
      <QueryProvider defaultVariables={props.qctx.defaultVariables.current}>
        <SpecificationsAccordionBody {...props} />
      </QueryProvider>
    );
  };
});

export const SpecificationsAccordionBody = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/specifications'))
    .SpecificationsAccordionBody
  : (props) => <SpecificationsAccordionBodyImport {...props} />;

export const SpecificationsAccordionBodyModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/specifications'))
    .SpecificationsAccordionBody.dataModel
  : {};

/** *********************
 * Product Overview
 ********************** */
export const ProductOverviewAccordionBodyLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "product-overview" */
  '@thd-olt-component-react/product-overview'
).then((module) => {
  const { ProductOverviewAccordionBody } = module;

  ProductOverviewAccordionBodyImport = (props) => {
    return (
      <QueryProvider defaultVariables={props.qctx.defaultVariables.current}>
        <ProductOverviewAccordionBody {...props} />
      </QueryProvider>
    );
  };
});

export const ProductOverviewAccordionBody = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/product-overview'))
    .ProductOverviewAccordionBody
  : (props) => <ProductOverviewAccordionBodyImport {...props} />;

export const ProductOverviewAccordionBodyModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/product-overview'))
    .ProductOverviewAccordionBody.dataModel
  : {};
